import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const OtaOfferLoading = () => (
  <Box
    display="flex"
    flexDirection="column"
    gap="s600"
    data-id="OtaOfferLoading"
  >
    <div>
      <SkeletonLoader width={180} />
      <SkeletonLoader width={200} />
    </div>
    <div>
      <SkeletonLoader width={120} />
      <SkeletonLoader width={140} />
    </div>
    <SkeletonLoader marginTop={0} />
  </Box>
)
